import wsStorage from "lib/wsStorage";

import { PROFILE_STRENGTH } from "lib/constants";

function getProfileStrength(numCompleted) {
    if (numCompleted <= 1) {
        return PROFILE_STRENGTH.OK;
    }

    if (numCompleted === 2) {
        return PROFILE_STRENGTH.GOOD;
    }

    return PROFILE_STRENGTH.EXCELLENT;
}

function getDetailLevel(avgDutiesChars) {
    if (avgDutiesChars < 50) {
        return "Limited";
    }

    if (avgDutiesChars < 100) {
        return "Good";
    }

    return "Great";
}

function getExperienceYears(months) {
    if (months < 12) {
        return "<1 year";
    }

    if (months === 12) {
        return "1 year";
    }

    // Round to the nearest 1/2 year
    const years = Math.round((months / 12) * 2) / 2;
    return `${years} years`;
}

/**
 * Pass in data from the profile api (meta.to_dict())
 */
export function profileCompletenessData({ profile_completeness: profileCompleteness, jobs }) {
    const { self_promo: selfPromo } = profileCompleteness;
    const avgDutiesChars = profileCompleteness.avg_duties_chars || 0;
    const workExperienceMonths = profileCompleteness.work_experience_months || 0;
    const jobCount = jobs.filter((j) => j.title).length;

    const tasks = {
        addJobs: workExperienceMonths >= 60 || !!wsStorage.getItem("doneAddingJobs"),
        jobDescriptions: avgDutiesChars >= 50,
        personalSummary: !!selfPromo,
    };

    const numberComplete = Object.values(tasks).filter((done) => done).length;
    const allComplete = numberComplete === Object.keys(tasks).length;

    return {
        tasks,
        numberComplete,
        allComplete,
        jobCount,
        strength: getProfileStrength(numberComplete),
        experienceYears: getExperienceYears(workExperienceMonths),
        detailLevel: getDetailLevel(avgDutiesChars),
    };
}
